import { withRouter } from 'next/router';
import React from 'react';
import Alert from 'react-bootstrap/lib/Alert';
import Modal from 'react-bootstrap/lib/Modal';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';
import Collapsible from 'react-collapsible';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import css from 'styled-jsx/css';
import faqContent from './faqContents';
import {
  makeSelectIsAuthenticated,
  makeSelectProfile,
} from '../AuthProvider/selectors';
import { makeSelectCurrentLanguage } from '../Language/selectors';
import withI18next from '~/../hocs/_withI18next';
import Breadcrumb from '~/components/Breadcrumb';
import GroupWebsites from '~/components/GroupWebsites';
import I18nLink from '~/components/I18nLink';
import Logo from '~/components/Layout/Logo';
import NewSurvey from '~/components/NewSurvey';
import Config from '~/config';
import themeVariables from '~/shared/themeVariables';
// import { openModal } from '../LoginModal/actions';

const { className, styles } = css.resolve`
  .help-page-header-image {
    margin-bottom: 0;
    margin-top: -1px;
    height: 400px;
  }
`;

@withI18next(['page-faq'])
class HelpPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      faqTab: 'SUBSCRIPTIONS',
      faqContent: [],
      modalMessageCancel: false,
      modalMessageDelete: false,
      listQuestions: [
        {
          question: 'help_page_content1',
          answer: 'help_page_content2',
        },
        {
          question: 'help_page_content3',
          answer: 'help_page_content4',
        },
        {
          question: 'help_page_content5',
          answer: 'help_page_content6',
        },
        {
          question: 'help_page_content7',
          answer: 'help_page_content8',
        },
        {
          question: 'help_page_content9',
          answer: 'help_page_content10',
          button_cancel: true,
          button_delete: false,
          show_link: false,
          link: 'help_page_link1',
          end: 'help_page_thanks1',
        },
        // {
        //   question: 'help_page_content11',
        //   answer: 'help_page_content12',
        //   button_cancel: false,
        //   button_delete: true,
        //   show_link: false,
        //   link: 'help_page_link2',
        //   end: 'help_page_thanks2',
        // },
        {
          question: 'help_page_content13',
          answer: 'help_page_content14',
        },
        {
          question: 'help_page_content15',
          answer: 'help_page_content16',
        },
        {
          question: 'help_page_content19',
          answer: 'help_page_content20',
        },
        {
          question: 'help_page_content21',
          answer: 'help_page_content22',
        },
      ],
    };
  }

  componentDidMount() {
    const tab = this.props.query.tab;

    const defaultTabContent = tab
      ? faqContent[`${tab.toUpperCase()}`]
      : faqContent[this.state.faqTab];

    this.setState({
      faqContent: defaultTabContent,
      faqTab: tab ? tab.toUpperCase() : 'SUBSCRIPTIONS',
    });
  }

  componentDidUpdate(prevProps) {
    const { query } = this.props.router;
    if (query.tab !== prevProps.router.query.tab) {
      const tab = this.props.query.tab;
      const defaultTabContent = tab
        ? faqContent[`${tab.toUpperCase()}`]
        : faqContent['SUBSCRIPTIONS'];
      this.setState({
        faqContent: defaultTabContent,
        faqTab: tab ? tab.toUpperCase() : 'SUBSCRIPTIONS',
      });
    }
  }

  handleSelectFaqTab = (selectedKey) => {
    if (this.state.faqTab === selectedKey) {
      return;
    }
    // window.history.pushState(null, null, `?tab=${selectedKey.toLowerCase()}`);
    this.props.router.push(`?tab=${selectedKey.toLowerCase()}`);
    const contentCurrentTab = faqContent[selectedKey];
    this.setState({ faqTab: selectedKey, faqContent: contentCurrentTab });
  };

  onCancel = (item, index) => {
    if (!this.props.isAuthenticated) {
      // this.props.openLoginModal();
      window.location.href = `${Config.ssoServerUrl}/login?lang=${
        this.props.lng
      }&serviceURL=${encodeURIComponent(
        process.browser ? window.location.href : '',
      )}`;
      return;
    }
    if (Config.getRoles().PREMIUM !== this.props.profile.role) {
      return this.setState({ modalMessageCancel: true });
    }

    const Obj = {
      ...this.state.listQuestions[index],
      button_cancel: !this.state.listQuestions[index].button_cancel,
      show_link: !this.state.listQuestions[index].show_link,
    };

    const { listQuestions } = this.state;
    listQuestions[index] = Obj;
    this.setState(
      {
        listQuestions: [...listQuestions],
      },
      () => {
        console.log(this.state);
      },
    );
  };

  onCancelAtTechinicalSupportTab = (item, index) => {
    if (!this.props.isAuthenticated) {
      // this.props.openLoginModal();
      window.location.href = `${Config.ssoServerUrl}/login?lang=${
        this.props.lng
      }&serviceURL=${encodeURIComponent(
        process.browser ? window.location.href : '',
      )}`;
      return;
    }
    if (Config.getRoles().PREMIUM !== this.props.profile.role) {
      return this.setState({ modalMessageCancel: true });
    }

    const Obj = {
      ...this.state.faqContent.content[index],
      button_cancel: !this.state.faqContent.content[index].button_cancel,
      show_link: !this.state.faqContent.content[index].show_link,
    };

    const { faqContent } = this.state;
    faqContent.content[index] = Obj;
    this.setState(
      {
        faqContent,
      },
      () => {
        console.log(this.state);
      },
    );
  };

  onDelete = (item, index) => {
    if (!this.props.isAuthenticated) {
      // this.props.openLoginModal();
      window.location.href = `${Config.ssoServerUrl}/login?lang=${
        this.props.lng
      }&serviceURL=${encodeURIComponent(
        process.browser ? window.location.href : '',
      )}`;
      return;
    }
    if (Config.getRoles().PREMIUM === this.props.profile.role) {
      return this.setState({ modalMessageDelete: true });
    }

    const Obj = {
      ...this.state.listQuestions[index],
      button_delete: !this.state.listQuestions[index].button_delete,
      show_link: !this.state.listQuestions[index].show_link,
    };

    const { listQuestions } = this.state;
    listQuestions[index] = Obj;
    this.setState(
      {
        listQuestions: [...listQuestions],
      },
      () => {
        console.log(this.state);
      },
    );
  };

  onDeleteAtTechinicalSupportTab = (item, index) => {
    if (!this.props.isAuthenticated) {
      // this.props.openLoginModal();
      window.location.href = `${Config.ssoServerUrl}/login?lang=${
        this.props.lng
      }&serviceURL=${encodeURIComponent(
        process.browser ? window.location.href : '',
      )}`;
      return;
    }
    if (Config.getRoles().PREMIUM === this.props.profile.role) {
      return this.setState({ modalMessageDelete: true });
    }

    const Obj = {
      ...this.state.faqContent.content[index],
      button_delete: !this.state.faqContent.content[index].button_delete,
      show_link: !this.state.faqContent.content[index].show_link,
    };

    const { faqContent } = this.state;
    faqContent.content[index] = Obj;
    this.setState(
      {
        faqContent,
      },
      () => {
        console.log(this.state);
      },
    );
  };

  handleClose = () => {
    this.setState({ modalMessageCancel: false, modalMessageDelete: false });
  };

  renderUrl(name) {
    const domain = Config.getListDomain(this.props.currentLanguage);
    const { DESIGN_AC } = domain;
    const { PHOTO_AC } = domain;
    const { ILLUST_AC } = domain;
    const { SILHOUETTE_AC } = domain;
    switch (name) {
      case 'silhouette_ac':
        return SILHOUETTE_AC;
      case 'photo_ac':
        return PHOTO_AC;
      case 'illust_ac':
        return ILLUST_AC;
      default:
        return DESIGN_AC;
    }
  }

  renderCollapseContents = (contents, isFrequentQuestion) => {
    const { t, currentLanguage } = this.props;
    if (!isFrequentQuestion) {
      return (
        <>
          {contents &&
            contents.map((item, index) => (
              <Collapsible
                key={index}
                transitionTime={200}
                trigger={`+ ${t(item.question)}`}
                className="faq_question"
                openedClassName="faq_question"
              >
                <div>
                  <p dangerouslySetInnerHTML={{ __html: t(item.answer) }} />
                  {item.button_cancel ? (
                    <button
                      style={{
                        fontSize: 12,
                        marginLeft: '20px',
                      }}
                      className={`button-${Config.serviceType} button-shadow`}
                      onClick={() =>
                        this.onCancelAtTechinicalSupportTab(item, index)
                      }
                    >
                      {/*Got It*/}
                      {this.props.t('button_got_it')}
                    </button>
                  ) : (
                    ''
                  )}
                  {item.button_delete && (
                    <button
                      style={{
                        fontSize: 12,
                        marginLeft: '20px',
                      }}
                      className={`button-${Config.serviceType} button-shadow`}
                      onClick={() =>
                        this.onDeleteAtTechinicalSupportTab(item, index)
                      }
                    >
                      {this.props.t('button_got_it')}
                    </button>
                  )}
                  {item.show_link && (
                    <div
                      style={{ marginLeft: '20px' }}
                      dangerouslySetInnerHTML={{
                        __html: t(item.link, {
                          domain: this.renderUrl(Config.serviceType),
                          currentLanguage,
                        }),
                      }}
                    />
                  )}
                  <div
                    dangerouslySetInnerHTML={{ __html: t(item.end) }}
                    style={{ paddingTop: '10px' }}
                  />
                </div>
              </Collapsible>
            ))}
        </>
      );
    }
    const domain = Config.getListDomain(currentLanguage);
    const { DESIGN_AC } = domain;
    const { PHOTO_AC } = domain;
    const { ILLUST_AC } = domain;
    const { SILHOUETTE_AC } = domain;
    return (
      <>
        {contents &&
          contents.map((item, index) => (
            <Collapsible
              key={index}
              transitionTime={200}
              trigger={`+ ${t(item.question)}`}
              className="faq_question"
              openedClassName="faq_question"
            >
              <div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t(item.answer, {
                      domainIllust: ILLUST_AC,
                      domainPhoto: PHOTO_AC,
                      domainSilhouete: SILHOUETTE_AC,
                      domainDesign: DESIGN_AC,
                      domain: this.renderUrl(Config.serviceType),
                      currentLanguage,
                    }),
                  }}
                />
                {item.button_cancel ? (
                  <button
                    style={{
                      fontSize: 12,
                      marginLeft: '20px',
                    }}
                    className={`button-${Config.serviceType} button-shadow`}
                    onClick={() => this.onCancel(item, index)}
                  >
                    {this.props.t('button_got_it')}
                  </button>
                ) : (
                  ''
                )}
                {item.button_delete && (
                  <button
                    style={{
                      fontSize: 12,
                      marginLeft: '20px',
                    }}
                    className={`button-${Config.serviceType} button-shadow`}
                    onClick={() => this.onDelete(item, index)}
                  >
                    {this.props.t('button_got_it')}
                  </button>
                )}
                {item.show_link && (
                  <div
                    style={{ marginLeft: '20px' }}
                    dangerouslySetInnerHTML={{
                      __html: t(item.link, {
                        domain: this.renderUrl(Config.serviceType),
                        currentLanguage,
                      }),
                    }}
                  />
                )}
                <div
                  dangerouslySetInnerHTML={{ __html: t(item.end) }}
                  style={{ paddingTop: '10px' }}
                />
              </div>
            </Collapsible>
          ))}
      </>
    );
  };

  renderTabContent = () => {
    const { faqContent } = this.state;
    if (faqContent) {
      return (
        <>
          <div className={`faq_question_container ${Config.serviceType}`}>
            <h3>{this.props.t(faqContent.title)}</h3>
            {faqContent.code === 'subscription' &&
              this.renderCollapseContents(faqContent.content)}
            {faqContent.code === 'payment_and_bill' &&
              this.renderCollapseContents(faqContent.content)}
            {faqContent.code === 'usage_guides' &&
              this.renderCollapseContents(faqContent.content)}
            {faqContent.code === 'technical_support' &&
              this.renderCollapseContents(faqContent.content)}
          </div>
        </>
      );
    }
    return '';
  };

  renderTabCategories = () => (
    <>
      <Nav
        bsStyle="tabs"
        className={`faq-category ${Config.serviceType} tab-categories`}
        justified
        activeKey={this.state.faqTab}
        onSelect={this.handleSelectFaqTab}
      >
        <NavItem
          eventKey="SUBSCRIPTIONS"
          title="Subscription"
          className={`faq-category-tab ${Config.serviceType}`}
        >
          {/* Subscription */}
          {this.props.t('faq_category_subscription')}
          <div className="arrow-tab" />
        </NavItem>

        <NavItem
          eventKey="PAYMENT_AND_BILL"
          title="Payment & Billing"
          className={`faq-category-tab ${Config.serviceType}`}
        >
          {/* Payment & Billing */}
          {this.props.t('faq_category_payment_&_billing')}
          <div className="arrow-tab" />
        </NavItem>
        <NavItem
          eventKey="USAGE_GUIDES"
          title="Usage Guides"
          className={`faq-category-tab ${Config.serviceType}`}
        >
          {/* Usage Guides */}
          {this.props.t('faq_category_usage_guides')}
          <div className="arrow-tab" />
        </NavItem>
        <NavItem
          eventKey="TECHNICAL_SUPPORT"
          title="Technical Support"
          className={`faq-category-tab ${Config.serviceType}`}
        >
          {/* Technical Support */}
          {this.props.t('faq_category_technical_support')}
          <div className="arrow-tab" />
        </NavItem>
      </Nav>
    </>
  );

  renderSearchBox = () => (
    <div
      className="row"
      style={{
        width: '100%',
      }}
    >
      <div className="col-md-3">
        <I18nLink href={{ pathname: '/' }} shallow>
          <a
            style={{
              float: 'left',
              margin: 16,
            }}
          >
            <Logo isFAQPage />
          </a>
        </I18nLink>
      </div>
      <div
        className="col-md-6"
        style={{
          marginTop: 25,
          color: '#3e3e3f',
        }}
      >
        <h1>{this.props.t(Config.getPrefixContent('heading_help_page'))}</h1>
        <h2>{this.props.t('faq_subtitle_Help?')}</h2>
      </div>
      <div className="col-md-3">
        <img
          style={{
            marginLeft: 40,
          }}
          src={`${Config.staticPrefix}/static/images/svg/categories.svg`}
          width="300"
          alt={'logo categories'}
        />
      </div>
    </div>
  );

  render() {
    const { currentLanguage, lng, t } = this.props;
    const domain = Config.getListDomain(currentLanguage);

    const { DESIGN_AC } = domain;
    const { PHOTO_AC } = domain;
    const { ILLUST_AC } = domain;
    const { SILHOUETTE_AC } = domain;

    return (
      <div>
        <div className="bg-white help-page-container">
          {/* <BackgroundRandomImgComponent className={`${className} help-page-header-image`} /> */}
          {/* <h1 className="title-head text-center bg-gray-head text-white">
            {t('credit_premium_FAQ_title')}
          </h1> */}

          <div className="faq-head text-center text-white">
            {this.renderSearchBox()}
            <div className="breadcrumb-wrapper">
              <Breadcrumb
                title={this.props.t(
                  Config.getPrefixContent('heading_help_page'),
                )}
              />
            </div>
            {this.renderTabCategories()}
          </div>
          <div className="container pt50 pb50">{this.renderTabContent()}</div>
          <div
            className={`faq-middle ${Config.serviceType} text-center text-white`}
          >
            {/*FREQUENTLY ASKED QUESTIONS*/}
            {this.props.t('faq_categoryTitle_frequent_questions')}
          </div>
          <div className="container pt50 pb50">
            <div className={`faq_question_container ${Config.serviceType}`}>
              {this.renderCollapseContents(this.state.listQuestions, true)}
            </div>

            <Modal
              bsSize="small"
              className="help-page"
              show={this.state.modalMessageCancel}
              onHide={this.handleClose}
            >
              <Modal.Body style={{ padding: 0, textAlign: 'center' }}>
                <Alert bsStyle="warning">
                  <b className="text-center" style={{ lineHeight: '1.5' }}>
                    Sorry ! This link is only for Premium account !
                  </b>
                </Alert>
              </Modal.Body>
            </Modal>
            <Modal
              bsSize="small"
              className="help-page"
              show={this.state.modalMessageDelete}
              onHide={this.handleClose}
            >
              <Modal.Body style={{ padding: 0 }}>
                <Alert bsStyle="warning">
                  <h4 className="text-center" style={{ lineHeight: '1.5' }}>
                    {/*You have to cancel your premium first*/}
                    {this.props.t('faq_pop-up_deleteMessage')}
                  </h4>
                </Alert>
              </Modal.Body>
            </Modal>
          </div>
          <div className="container">
            <div className="faq-contact">
              <span>
                {/* Should any further questions arise, please feel free to contact
                us via */}
                {this.props.t('faq_footer_contact1')} <b>info@acworks.co.jp</b>
              </span>
              <span>
                {/*We truly appreciate your support.*/}
                {this.props.t('faq_footer_contact2')}
              </span>
              <div style={{ marginTop: 30 }} className="group-website-icon">
                <GroupWebsites t={this.props.t} isAboutPage />
              </div>
            </div>
            <div
              className="faq-contact-mobile"
              dangerouslySetInnerHTML={{
                __html: t('faq_footer_contact3'),
              }}
            />
          </div>
          {lng === 'en' && <NewSurvey t={t} />}
        </div>
        {styles}
        <style jsx global>
          {`
            @media (min-width: ${themeVariables.breakpoints.tabletL
                .minWidth}px) {
              .help-page-container {
                margin-top: -70px;
              }
            }
            .faq-contact-mobile {
              display: none;
            }
            .faq-head {
              background-color: #e8f7fb;
              color: #2f2f60;
              margin: 0;
              text-align: center;
              font-size: 22px;
              display: flex;
              flex-direction: column;
            }

            .faq-middle {
              color: #fff;
              text-align: center;
              font-size: 22px;
              padding: 20px 0px;
            }

            .faq-contact {
              display: flex;
              flex-direction: column;
              text-align: center;
              font-size: 22px;
              color: #2f2f60;
              padding: 50px 0;
            }

            .faq-middle.photo_ac {
              background-color: #509bdc;
            }

            .faq-middle.illust_ac {
              background-color: #d73a4e;
            }

            .faq-middle.silhouette_ac {
              background-color: #41b9b8;
            }

            .faq-middle.design_ac {
              background-color: #ffa823;
            }

            .faq-category {
              padding: 0 25px;
            }

            .faq-category .faq-category-tab {
              background-color: #cccccc;
              border-right: 3px solid #e8f7fb;
            }

            .faq-category .faq-category-tab .arrow-tab {
              width: 0;
              height: 0;
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              top: 50px;
              left: 46%;
              position: absolute;
              z-index: 101;
              display: none;
            }

            .faq-category .faq-category-tab a {
              color: #fff;
              border-radius: 0 !important;
            }

            .faq-category .faq-category-tab.photo_ac .arrow-tab {
              border-top: 10px solid #509bdc;
            }

            .faq-category .faq-category-tab.illust_ac .arrow-tab {
              border-top: 10px solid #d73a4e;
            }

            .faq-category .faq-category-tab.silhouette_ac .arrow-tab {
              border-top: 10px solid #41b9b8;
            }

            .faq-category .faq-category-tab.design_ac .arrow-tab {
              border-top: 10px solid #ffa823;
            }

            .faq-category.photo_ac li.active a,
            .faq-category.photo_ac li.active a:focus,
            .faq-category.photo_ac li.active a:hover {
              color: #fff;
              background-color: #509bdc;
              border-bottom: none;
            }

            .faq-category.illust_ac li.active a,
            .faq-category.illust_ac li.active a:focus,
            .faq-category.illust_ac li.active a:hover {
              color: #fff;
              background-color: #d73a4e;
              border-bottom: none;
            }

            .faq-category.silhouette_ac li.active a,
            .faq-category.silhouette_ac li.active a:focus,
            .faq-category.silhouette_ac li.active a:hover {
              color: #fff;
              background-color: #41b9b8;
              border-bottom: none;
            }

            .faq-category.design_ac li.active a,
            .faq-category.design_ac li.active a:focus,
            .faq-category.design_ac li.active a:hover {
              color: #fff;
              background-color: #ffa823;
              border-bottom: none;
            }

            .faq-category li.active a .arrow-tab {
              display: block;
            }

            .faq_question {
              border-bottom: 1px solid #cccccc;
              padding: 10px 0px;
            }

            .faq_question_container h3 {
              font-size: 30px;
              text-align: center;
            }

            .faq_question_container.photo_ac h3,
            .faq_question_container.photo_ac a {
              color: #509bdc;
            }

            .faq_question_container.illust_ac h3,
            .faq_question_container.illust_ac a {
              color: #d73a4e;
            }

            .faq_question_container.silhouette_ac h3,
            .faq_question_container.silhouette_ac a {
              color: #41b9b8;
            }

            .faq_question_container.design_ac h3,
            .faq_question_container.design_ac a {
              color: #ffa823;
            }

            .faq_question .Collapsible__trigger {
              font-size: 20px;
              font-weight: 500;
              color: #2f2f60;
              padding: 15px 0px;
              display: block;
              cursor: pointer;
            }

            .chat-wrapper {
              width: 100%;
              display: table;
              overflow: hidden;
              padding: 15px 100px;
            }

            .button-shadow {
              border-radius: 60px;
              height: 35px;
              padding-right: 20px;
              padding-left: 20px;
              color: #fff;
              border: none;
              font-weight: 400;
            }

            .chat-wrapper:before {
              content: ' ';
              display: block;
            }

            .chat-wrapper .chat-content {
              background-color: #3e3e3f;
            }

            .chat-wrapper .chat-image {
              float: left;
              border-radius: 50%;
            }

            .chat-wrapper .chat-image.chat-image-default {
              width: 60px;
              height: 60px;
            }

            .chat-wrapper .chat-message {
              margin-bottom: 20px;
              width: 100%;
              display: table;
              overflow: hidden;
            }

            .chat-wrapper .chat-message:before {
              content: ' ';
              display: block;
            }

            .chat-wrapper .chat-message:last-of-type {
              margin-bottom: 0;
            }

            .chat-wrapper .chat-message .chat-message-wrapper {
              max-width: 70%;
              display: table;
              margin: 0 20px;
              padding-top: 10px;
              position: relative;
            }

            .chat-wrapper .chat-message .chat-message-wrapper:before {
              content: ' ';
              display: block;
              width: 0;
              height: 0;
              border: 12px solid transparent;
              top: 20px;
              position: absolute;
              z-index: 2;
            }

            .chat-wrapper .chat-message .chat-message-wrapper p {
              padding: 10px 20px;
              color: #fff;
              background: #3e3e3f;
              border-radius: 2px;
            }

            .chat-wrapper .chat-message .chat-message-wrapper p:first-of-type {
              border-top: 0 !important;
            }

            .chat-wrapper
              .chat-message.chat-message-recipient
              .chat-message-wrapper,
            .chat-wrapper
              .chat-message.chat-message-recipient
              .chat-message-content {
              float: left;
            }

            .chat-wrapper
              .chat-message.chat-message-recipient
              .chat-message-wrapper:before {
              left: -20px;
              border-right-color: #fff;
            }

            .chat-wrapper .chat-message.chat-message-recipient p {
              background-color: #fff;
              color: #1b2833;
              border-radius: 2px;
            }

            .chat-wrapper
              .chat-message.chat-message-sender
              .chat-message-wrapper,
            .chat-wrapper
              .chat-message.chat-message-sender
              .chat-message-content {
              float: right;
            }

            .chat-wrapper
              .chat-message.chat-message-sender-design_ac
              .chat-message-wrapper:before {
              right: -20px;
              border-left-color: #3e3e3f;
            }

            .chat-wrapper .chat-message.chat-message-sender-design_ac p {
              background: #3e3e3f;
              color: #fff;
              border-radius: 2px;
            }

            .chat-wrapper
              .chat-message.chat-message-sender-illust_ac
              .chat-message-wrapper:before {
              right: -20px;
              border-left-color: #fff;
            }

            .chat-wrapper .chat-message.chat-message-sender-illust_ac p {
              background: #fff;
              color: #1b2833;
              border-radius: 2px;
            }

            .chat-wrapper
              .chat-message.chat-message-sender-photo_ac
              .chat-message-wrapper:before {
              right: -20px;
              border-left-color: #fff;
            }

            .chat-wrapper .chat-message.chat-message-sender-photo_ac p {
              background: #fff;
              color: #1b2833;
              border-radius: 2px;
            }

            .chat-wrapper
              .chat-message.chat-message-sender-silhouette_ac
              .chat-message-wrapper:before {
              right: -20px;
              border-left-color: #fff;
            }

            .chat-wrapper .chat-message.chat-message-sender-silhouette_ac p {
              background: #fff;
              color: #1b2833;
              border-radius: 2px;
            }

            .chat-wrapper .chat-message.chat-message-sender img {
              float: right;
            }

            .chat-wrapper .chat-message .chat-message-content {
              display: table;
              overflow: hidden;
              border-radius: 2px;
            }

            .chat-wrapper .chat-message .chat-message-content:before {
              content: ' ';
              display: block;
            }

            .chat-wrapper .chat-message .chat-details {
              clear: both;
              width: 100%;
              display: table;
              overflow: hidden;
            }

            .chat-wrapper .chat-message .chat-details:before {
              content: ' ';
              display: block;
            }

            .chat-wrapper .chat-message .chat-details span {
              margin-right: 4px;
              color: #bbb;
            }

            @media (max-width: 992px) {
              .chat-wrapper {
                padding: 15px;
              }
            }

            .chat-wrapper .chat-message .chat-message-content:before {
              right: -20px;
              border-left-color: #ffd1a4;
            }

            .color-title-design_ac {
              color: #fff;
            }

            .background-content-faq {
              border-radius: 2px;
              padding: 20px;
            }

            .help-page .modal-content {
              box-shadow: none;
              border: 0;
              border-radius: 2px;
              width: 350px;
            }

            .breadcrumb-wrapper {
              padding: 5px 25px;
              align-self: flex-start;
              font-size: 14px;
            }
            @media (max-width: ${themeVariables.breakpoints.tabletS
                .minWidth}px) {
              .group-website-icon {
                display: none;
              }
              .tab-categories {
                display: flex;
                position: relative;
                overflow-x: scroll;
                display: flex;
                scroll-behavior: smooth;
                overflow-y: hidden;
              }

              .tab-categories .faq-category-tab {
                min-width: 200px;
                height: 48px;
                font-size: 18px;
              }
              .faq-category {
                padding: 0 10px !important;
              }
              .faq-contact {
                display: none;
              }
              .faq-contact-mobile {
                display: block;
                padding: 16px 0;
                font-size: 18px;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: makeSelectIsAuthenticated(),
  currentLanguage: makeSelectCurrentLanguage(),
  profile: makeSelectProfile(),
});
const mapDispatchToProps = (dispatch) => ({
  // openLoginModal: index => dispatch(openModal(index)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(HelpPage));
